import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { formatTime } from "../../utils/timeUtils";

const LiveClock = () => {
  const [time, setTime] = useState(formatTime(new Date()));

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(formatTime(new Date()));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      className="live-clock"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2>{time}</h2>
    </motion.div>
  );
};

export default LiveClock;
